// extracted by mini-css-extract-plugin
export default {"container":"InvoiceTopMore_container__MxN-G"};